import * as React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, MantineProvider } from '@mantine/core';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './auth/AuthContext';
import { routes } from './routes';

const theme = createTheme({
  /** Put your mantine theme override here */
});

const router = createBrowserRouter(routes);

export default function App() {
  // prettier-ignore
  return (
    <AuthProvider>
      <MantineProvider theme={theme}>
      <RouterProvider router={router} />
      <ToastContainer />
    </MantineProvider>
    </AuthProvider>
  );
}
